<div class="page">
  <mat-toolbar color="white" class="toolbar">
    <mat-toolbar-row>
      <div class="toolbar-row-container">
        <div class="make-booking-header">
          <div class="profile-picture">
            <div class="practice-logo" *ngIf="practice?.logo">
              <gc-profile-picture [imgSrc]="practice?.logo"></gc-profile-picture>
            </div>
            <span class="heading-1">{{ practiceName }}</span>
          </div>
          <button mat-icon-button color="primary" type="button" (click)="logout()" *ngIf="(isMobile$ | async) && (authenticated$ | async)">
            <mat-icon svgIcon="logout"></mat-icon>
          </button>
          <button
            mat-raised-button
            color="accent"
            type="button"
            (click)="logout()"
            *ngIf="(isMobile$ | async) === false && (authenticated$ | async)"
          >
            <mat-icon svgIcon="logout"></mat-icon>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
  <div class="fetch" *ngIf="error.hasError === undefined; else practiceTimeslots">
    <h1 class="heading-1">Fetching Information...</h1>
  </div>
  <ng-template #practiceTimeslots>
    <div *ngIf="!error.hasError" ngClass="doctor">
      <h2 class="heading-1">First Available Booking</h2>
      <section class="section-container">
        <div *ngIf="timeslotDiaries.length === 0" class="no-booking-slots">
          <div class="empty-practice">
            <div class="empty-practice-text">
              <p>No booking slots available. Please contact the practitioner or practice directly.</p>
              <h3 *ngIf="practice.contactNumbers.length">Practice Numbers</h3>
              <a *ngFor="let number of practice.contactNumbers" [href]="'tel:' + number">{{ number }}</a>
            </div>
          </div>
        </div>
        <div *ngFor="let diary of timeslotDiaries" class="timeslot-diary" [formGroup]="bookingTypeSelectors">
          <div class="details-row">
            <div class="profile-pic-container">
              <gc-profile-picture [fullName]="diary.name" [imgSrc]="diary.logo"></gc-profile-picture>
            </div>
            <div>
              <h3>{{ diary.name }}</h3>
              <span *ngIf="diary.timezone_json?.timezone" class="doctor-timzone">
                Time zone: {{ diary.timezone_json?.timezone }} ({{ diary.timezone_json?.timezone_offset }})
              </span>
              <p class="subtext">{{ diary.booking_types.length }} Shared booking types</p>
            </div>
          </div>
          <div class="booking-types-row">
            <div class="booking-type">
              <mat-form-field appearance="outline" class="width-restrict">
                <mat-label>Booking Type</mat-label>
                <mat-select *ngIf="timeslotDiaries.length > 0" [formControlName]="diary.diary_uuid" [compareWith]="comparisonFn">
                  <mat-option *ngFor="let bookingType of getBookingTypes(diary.diary_uuid)" [value]="bookingType">
                    {{ bookingType.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="timeslot-button">
              <button mat-raised-button color="primary" class="width-restrict" (click)="gotoBookingPage(diary.diary_uuid)">
                {{ timeslotByDiaryUuid(diary.diary_uuid) }}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div *ngIf="error.hasError" class="practice-error">
      <h2 class="heading-1">Error getting practice timeslots</h2>
      <div class="error-container">
        <span class="error-heading">{{ error.message }}</span>
      </div>
      <button mat-raised-button color="primary" (click)="retry()">
        Retry
        <mat-icon svgIcon="refresh"></mat-icon>
      </button>
      <img class="error-img" src="assets/images/Oops-error.svg" alt="Oops-error" />
    </div>
  </ng-template>
</div>
